import { CustomFieldType } from 'src/app/+shared/custom-fields/models/enums/customFieldType';
import { ApplicationSectionKeys } from 'src/app/constants/app.constants';

const addressSuffix = {
  name: 'addressSuffix',
  label: 'personal-data.form-details.fields.address-suffix',
  section: ApplicationSectionKeys.personalData.connectionAddress,
  type: CustomFieldType.Text,
  columnOffset: 6,
};

const housingUnits = {
  name: 'housingUnits',
  label: 'personal-data.form-details.fields.housing-units',
  section: ApplicationSectionKeys.personalData.connectionAddress,
  type: CustomFieldType.Number,
  required: true,
};

const apartmentNo = {
  name: 'apartmentNo',
  label: 'personal-data.form-details.fields.apartment-number',
  section: ApplicationSectionKeys.personalData.connectionAddress,
  type: CustomFieldType.Text,
};

const floor = {
  name: 'floor',
  label: 'personal-data.form-details.fields.floor-number',
  section: ApplicationSectionKeys.personalData.connectionAddress,
  type: CustomFieldType.Text,
  columnOffset: 6,
};

export default {
  addressSuffix,
  apartmentNo,
  floor,
  housingUnits,
};
